import React from "react";
import Modal from "../modal";
import styles from "./avatarModal.module.css";
import { IoMdClose, IoMdCamera, IoMdImage, IoMdLock } from "react-icons/io";
import useAvatares from "../../hooks/useAvatares";
import useAuth from "../../hooks/useAuth";
import { useDispatch } from "react-redux";
import { setPlayer1, setPlayer2 } from "../../store/slices/players";

import { useTranslation } from "react-i18next";

export default function AvatarModal({ visible, setVisible }) {
  const { t } = useTranslation();
  const { images } = useAvatares();
  const { user } = useAuth();
  const dispatch = useDispatch();

  const handleClose = () => {
    setVisible(false);
  };

  const handleSelectAvatar = (avatar) => {
    const target = document.getElementById(`player${visible}-image`);
    target.value = "";
    if (visible === 1) {
      dispatch(setPlayer1({ avatar }));
    } else {
      dispatch(setPlayer2({ avatar }));
    }
    handleClose();
  };

  const handlePremium = () => {
    // handleClose();
  };

  const handleCamera = () => {
    const target = document.getElementById(`player${visible}-image`);
    target.setAttribute("capture", "user");
    target.click();
  };
  const handleGalery = () => {
    const target = document.getElementById(`player${visible}-image`);
    target.removeAttribute("capture");
    target.click();
  };

  return (
    <Modal
      className={styles.wraper}
      classNameOverlay="!p-0"
      visible={visible}
      handleClose={handleClose}
    >
      <div className={styles.container}>
        <div className="flex items-center justify-between text-center pt-2 pb-2">
          <div className="pl-2 pt-2 -mt-2">
            <IoMdClose color="transparent" size={26} />
          </div>
          <h1 className="flex-1 text-black font-bold text-lg">
            {t("carregar")}
          </h1>
          <button
            onClick={handleClose}
            className="touchable-opacity pr-2 pt-2 -mt-2"
          >
            <IoMdClose color="black" size={26} />
          </button>
        </div>
        <div className="text-center mb-2">
          <span className="text-[#838383]">{t("takePhoto")}</span>
        </div>
        <div className="flex justify-center mb-1">
          <div className="flex">
            <button
              type="button"
              onClick={handleCamera}
              className={`${styles.customButton} touchable-opacity bg-[#FB9191]`}
            >
              <IoMdCamera size={28} />
            </button>
            <div className={styles.barra}></div>
            <button
              type="button"
              onClick={handleGalery}
              className={`${styles.customButton} touchable-opacity bg-[#FF5A5A]`}
            >
              <IoMdImage size={28} />
            </button>
          </div>
        </div>
        <div className="text-center mb-2">
          <span className="text-black font-bold text-lg">{t("useAvatar")}</span>
        </div>
        <div className={styles.scroll}>
          {Object.keys(images).map((item, index) => {
            const avatar = images[item].avatar;
            const isLocked = index > 5 && !user?.premium;

            return (
              <div key={`avatar-${item}`} className="flex justify-center">
                <button
                  type="button"
                  className={`${styles.avatar} touchable-opacity`}
                  onClick={() => {
                    if (isLocked) {
                      handlePremium();
                    } else {
                      handleSelectAvatar(avatar);
                    }
                  }}
                >
                  <div className={`${styles.locked}`}>
                    <div className={`${isLocked ? "" : "!hidden"}`}>
                      <IoMdLock size={32} color="white" />
                    </div>
                    <img src={avatar} alt={avatar} />
                  </div>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </Modal>
  );
}
